/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetFilesForPersonCommandResponse } from '../models/GetFilesForPersonCommandResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class DownloadApiService {
    constructor(public readonly http: HttpClient) {}
    /**
     * @param personId
     * @returns GetFilesForPersonCommandResponse OK
     * @throws ApiError
     */
    public getApiV10FilesDownloadGetFilesForPerson(
        personId: string,
    ): Observable<GetFilesForPersonCommandResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v1.0/Files/Download/GetFilesForPerson/{personId}',
            path: {
                'personId': personId,
            },
        });
    }
    /**
     * @param personGuid
     * @param fileId
     * @returns binary OK
     * @throws ApiError
     */
    public getApiV10FilesDownloadDownloadFile(
        personGuid: string,
        fileId: string,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v1.0/Files/Download/DownloadFile/{personGuid}/{fileId}',
            path: {
                'personGuid': personGuid,
                'fileId': fileId,
            },
        });
    }
}
